import React from 'react';
import { Pane, Spinner } from 'evergreen-ui';

export const Loader: React.FC = () => (
  <Pane display="flex" alignItems="center" justifyContent="center" height={400}>
    <Spinner />
  </Pane>
);
